import { FieldDef, formatDate, formatDollarAmount } from "@synota-io/synota-shared-ui";
import { IServiceChargePayment } from "../../../../api/hooks/useServiceChargePayments";

export const serviceChargePaymentFields: FieldDef<IServiceChargePayment>[] = [
  {
    field: "payment_id",
    headerName: "Payment ID",
    minWidth: 100,
    headerAlign: "right",
    align: "right",
  },
  {
    field: "payer_name",
    headerName: "Payer",
    minWidth: 160,
    type: "string",
  },
  {
    field: "payment_amount",
    headerName: "Payment Amount",
    minWidth: 100,
    type: "number",
    valueFormatter: (value) => formatDollarAmount(value),
  },
  {
    field: "payment_status",
    headerName: "Payment Status",
    minWidth: 120,
    type: "string",
  },
  {
    field: "ach_id",
    headerName: "ACH ID",
    minWidth: 160,
    type: "string",
  },
  {
    field: "initiated_date",
    headerName: "Initiated",
    minWidth: 140,
    type: "number",
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "withdrawal_date",
    headerName: "Withdrawn",
    minWidth: 140,
    type: "number",
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "paid_datetime",
    headerName: "Paid Date",
    minWidth: 140,
    type: "number",
    valueFormatter: (value) => formatDate(value),
  },
];
